"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { BespokeStudio } from "./BespokeStudio";
import { StudioClient } from "./StudioClient";
import { logout } from "./actions";
import type { BespokeDemo, StudioBrand } from "./page";

const MONO = { fontFamily: "var(--font-geist-mono), monospace" };
const FONT = { fontFamily: "var(--font-geist-sans), system-ui, sans-serif" };

export function StudioShell({
  bespoke,
  brands,
}: {
  bespoke: BespokeDemo[];
  brands: StudioBrand[];
}) {
  const router = useRouter();
  const [tab, setTab] = useState<"bespoke" | "library">("bespoke");

  return (
    <div style={FONT} className="min-h-screen bg-[#080808] text-white">
      <header className="flex flex-wrap items-center justify-between gap-4 border-b border-white/5 px-6 py-4 md:px-10">
        <span style={MONO} className="text-[0.7rem] uppercase tracking-[0.4em] text-white/50">
          FORMED · Demo Studio
        </span>
        <div className="flex items-center gap-1 rounded-full border border-white/10 bg-white/[0.03] p-1">
          <button
            onClick={() => setTab("bespoke")}
            className={`rounded-full px-4 py-1.5 text-sm transition-colors ${
              tab === "bespoke"
                ? "bg-gradient-to-r from-[#ee4f27] to-[#9c40ff] font-medium text-white"
                : "text-white/50 hover:text-white/80"
            }`}
          >
            Bespoke
          </button>
          <button
            onClick={() => setTab("library")}
            className={`rounded-full px-4 py-1.5 text-sm transition-colors ${
              tab === "library"
                ? "bg-gradient-to-r from-[#ee4f27] to-[#9c40ff] font-medium text-white"
                : "text-white/50 hover:text-white/80"
            }`}
          >
            Bibliothek
          </button>
        </div>
        <button
          onClick={() => logout().then(() => router.refresh())}
          className="text-xs text-white/40 underline-offset-2 hover:text-white/70 hover:underline"
        >
          Abmelden
        </button>
      </header>

      {tab === "bespoke" ? (
        <BespokeStudio demos={bespoke} />
      ) : (
        <StudioClient brands={brands} />
      )}
    </div>
  );
}
